import { ConstantVariables } from "SuperAdmin/Config/ConstantVariables";
import { Select, Spin } from "antd";
import { useEffect, useState } from "react";
import useDebounce from "../UseDebounce/useDebounce";
import styles from "./SelectComponents.module.scss";
import { IconPack } from "SuperAdmin/Config/Icon";

const SelectMappedProfile = ({
  placeholder,
  functionSearch,
  form,
  profileData,
  mappedProfile = null,
}) => {
  const [query, setQuery] = useState("");
  const [options, setOptions] = useState([]);
  const debouncedValue = useDebounce(query);
  const [isLoading, setIsLoading] = useState(false);
  const [chosenData, setChosenData] = useState(null);
  const renderItem = (option) => {
    const data = option.data;
    return (
      <div
        className={styles["profile-summary"]}
        onClick={() => handleSelectProfile(data)}
      >
        <div className={styles["profile-img"]}>
          {data.photo ? (
            <img src={data?.photo} alt="mapped-profile-photo" />
          ) : (
            <img
              src={ConstantVariables.no_photo_faculty}
              alt="mapped-profile-photo"
            />
          )}
        </div>
        <div className={styles["profile-info"]}>
          <p className={styles["profile-name"]}>{data?.name}</p>
          <p>{data?.department?.inst_name}</p>
          <p>{data?.position}</p>
        </div>
      </div>
    );
  };
  useEffect(() => {
    setChosenData(mappedProfile);
  }, [mappedProfile]);
  useEffect(() => {
    if (debouncedValue) {
      setIsLoading(true);
      setOptions([]);
      functionSearch({ query: debouncedValue }, (res) => {
        setOptions(res.results);
        setIsLoading(false);
      });
    }
  }, [debouncedValue]);
  const handleInputChange = (value) => {
    setQuery(value);
  };
  const handleSelectProfile = (value) => {
    setChosenData(value);
    form.setFieldsValue({
      mapped_profile_id: value.id,
      name: value?.name,
      email: value.email,
      institution_name: value?.department.inst_name,
      institution_id: value?.department.id,
      department: ["Computer science"],
      position: value?.position,
      profile_url: "https://cals.cornell.edu/tobias-doerr",
      photo_url: value?.photo,
    });
  };
  const handleDeleteChosenProfile = () => {
    setChosenData(null);
    form.resetFields();
    form.setFieldsValue({
      mapped_profile_id: null,
      name: profileData.name,
      email: profileData.email,
      institution: profileData.institution,
      department: profileData.department,
      position: profileData.position,
      profile_url: profileData.profile_url,
      activate: profileData.activate ? 1 : 2,
      role: profileData.role,
      photo: profileData.photo_url,
    });
  };

  return (
    <div className={styles["select-mapped-profile"]}>
      <Select
        showSearch
        placeholder={placeholder}
        filterOption={false}
        onSearch={handleInputChange}
        notFoundContent={isLoading ? <Spin size="small" /> : null}
        options={options}
        optionRender={(option) => renderItem(option)}
        searchValue={query}
        disabled={chosenData}
      />
      {chosenData && (
        <div className={styles["chosen-profile"]}>
          <div className={styles["profile"]}>
            <div className={styles["profile-img"]}>
              {chosenData.photo ? (
                <img src={chosenData?.photo} alt="mapped-profile-photo" />
              ) : (
                <img
                  src={ConstantVariables.no_photo_faculty}
                  alt="mapped-profile-photo"
                />
              )}
            </div>
            <div className={styles["profile-info"]}>
              <p className={styles["profile-name"]}>{chosenData?.name}</p>
              <p>{chosenData?.department?.inst_name}</p>
              <p>{chosenData?.position}</p>
            </div>
          </div>
          {mappedProfile ? (
            <div className={styles["open-detail-profile"]}>
              <p>Detail</p>
              {IconPack.navigate_icon}
            </div>
          ) : (
            <div
              className={styles["delete-chosen-profile"]}
              onClick={(e) => {
                e.preventDefault();
                handleDeleteChosenProfile();
              }}
            >
              {IconPack.close_icon}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SelectMappedProfile;
